import { createPath } from "@/service/routing/routing";

export const videoCardBadgeStyles =
  "rounded-md px-1.5 backdrop-blur-blur opacity-90 h-[20px] leading-[1] border-none absolute uppercase";

export function createPlaylistPath({
  slug,
  id,
}: PlaylistPreviewVM | PlaylistTreatedAsVideoPreviewVM) {
  return createPath("video.show", {
    slug,
    id,
  });
}

export function createPlaylistEpisodePath({
  slug,
  id,
  playlist,
}: PlaylistEpisodePreviewVM) {
  return createPath("video.playlist.show", {
    slug: playlist.slug,
    id: playlist.id,
    videoSlug: slug,
    videoId: id,
  });
}
